const positiveIntegerRegExp = /^\d{1,3}((:?,\d{3})*|(:? \d{3})*|(:?\d{3})*)$/;
const removeSeparatorsRegExp = / |,/g;

export const parsePositiveInteger = (value: string) =>
  positiveIntegerRegExp.test(value)
    ? Number.parseInt(value.replaceAll(removeSeparatorsRegExp, ''), 10)
    : NaN;
